import React from 'react';
import { Box, Text, Image } from '@chakra-ui/react';

const ReportHeader = ({ date, title, caseNumber }) => {
  const currentDate = date || new Date().toLocaleDateString('ar-SA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    calendar: 'islamic-umalqura'
  });

  return (
    <Box
      as="header"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      mb={8}
      pb={4}
      borderBottom="2px solid"
      borderColor="gray.800"
      direction="rtl"
      sx={{
        '@media print': {
          position: 'relative',
          pageBreakAfter: 'avoid',
          pageBreakInside: 'avoid',
          marginTop: '0 !important',
          marginBottom: '0 !important',
          marginLeft: '0 !important',
          marginRight: '0 !important',
          paddingTop: '0 !important',
          paddingBottom: '0.3cm !important',
          paddingLeft: '0 !important',
          paddingRight: '0 !important',
          display: 'flex !important',
          flexDirection: 'row !important',
          justifyContent: 'space-between !important',
          alignItems: 'flex-start !important',
          borderBottom: '2px solid #000 !important',
          width: '100% !important',
          maxWidth: '100% !important',
          top: '0',
          direction: 'rtl !important',
        },
      }}
    >
      <Box 
        flex={1} 
        textAlign="center" 
        pl={8}
        sx={{
          '@media print': {
            flex: '1 !important',
            paddingLeft: '0.5cm !important',
            paddingRight: '0 !important',
            textAlign: 'center !important',
            width: 'auto !important',
            minWidth: '0 !important',
            maxWidth: 'none !important',
          },
        }}
      >
        <Text 
          fontSize="sm" 
          fontWeight="semibold" 
          color="gray.800" 
          mb={1}
          sx={{
            '@media print': {
              fontSize: '10pt !important',
              marginBottom: '2px !important',
            },
          }}
        >
          المملكة العربية السعودية
        </Text>
        <Text 
          fontSize="sm" 
          fontWeight="semibold" 
          color="gray.800" 
          mb={1}
          sx={{
            '@media print': {
              fontSize: '10pt !important',
              marginBottom: '2px !important',
            },
          }}
        >
          وزارة الداخلية
        </Text>
        <Text 
          fontSize="sm" 
          fontWeight="semibold" 
          color="gray.800" 
          mb={1}
          sx={{
            '@media print': {
              fontSize: '10pt !important',
              marginBottom: '2px !important',
            },
          }}
        >
          الأمن العام
        </Text>
        <Text 
          fontSize="sm" 
          fontWeight="semibold" 
          color="gray.800" 
          mb={1}
          sx={{
            '@media print': {
              fontSize: '10pt !important',
              marginBottom: '2px !important',
            },
          }}
        >
          الإدارة العامة للأدلة الجنائية
        </Text>
        <Text 
          fontSize="sm" 
          fontWeight="semibold" 
          color="gray.800" 
          mb={1}
          sx={{
            '@media print': {
              fontSize: '10pt !important',
              marginBottom: '2px !important',
            },
          }}
        >
          إدارة تحقيق الشخصية
        </Text>
      </Box>

      <Box 
        flex="0 0 auto" 
        textAlign="center" 
        px={8}
        sx={{
          '@media print': {
            flex: '0 0 auto !important',
            paddingLeft: '0.3cm !important',
            paddingRight: '0.3cm !important',
            textAlign: 'center !important',
            width: 'auto !important',
            minWidth: '0 !important',
            maxWidth: 'none !important',
          },
        }}
      >
        <Text 
          fontSize="md" 
          fontWeight="semibold" 
          color="gray.800" 
          mb={4}
          sx={{
            '@media print': {
              fontSize: '11pt !important',
              marginBottom: '4px !important',
            },
          }}
        >
          بسم الله الرحمن الرحيم
        </Text>
        <Box 
          mt={2}
          sx={{
            '@media print': {
              marginTop: '4px !important',
            },
          }}
        >
          <Image
            src={`${process.env.PUBLIC_URL || ''}/logo-security.png`}
            alt="شعار الأمن العام"
            maxW="140px"
            maxH="160px"
            mx="auto"
            sx={{
              '@media print': {
                maxW: '120px !important',
                maxH: '140px !important',
                display: 'block !important',
                margin: '0 auto !important',
              },
            }}
          />
        </Box>
        <Text 
          fontSize="sm" 
          fontWeight="bold" 
          color="red.600" 
          mt={3}
          className="report-title-red"
          style={{ color: '#dc2626' }}
          sx={{
            color: '#dc2626 !important',
            '@media print': {
              fontSize: '11pt !important',
              fontWeight: 'bold !important',
              marginTop: '6px !important',
              display: 'block !important',
              color: '#dc2626 !important',
            },
          }}
        >
          {title || 'تقرير الفحوص الفنية للبصمات'}
          {caseNumber && (
            <span>
              {' '}رقم{' '}
              <span dir="ltr" style={{ display: 'inline-block' }}>{caseNumber}</span>
            </span>
          )}
        </Text>
      </Box>

      <Box 
        flex={1} 
        textAlign="center" 
        pr={8}
        sx={{
          '@media print': {
            flex: '1 !important',
            paddingRight: '0.5cm !important',
            paddingLeft: '0 !important',
            textAlign: 'center !important',
            width: 'auto !important',
            minWidth: '0 !important',
            maxWidth: 'none !important',
          },
        }}
      >
        <Box 
          mb={3}
          sx={{
            '@media print': {
              marginBottom: '0 !important',
            },
          }}
        >
          <Text 
            fontSize="sm" 
            fontWeight="bold" 
            color="gray.800" 
            as="span"
            sx={{
              '@media print': {
                fontSize: '10pt !important',
              },
            }}
          >
            التاريخ :
          </Text>
          <Text 
            fontSize="sm" 
            color="gray.600" 
            as="span" 
            mr={2}
            sx={{
              '@media print': {
                fontSize: '10pt !important',
                marginRight: '4px !important',
              },
            }}
          >
            {currentDate}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default ReportHeader;
